import React from 'react'
import { FormComponent } from '../../../components/form/DynamicForm'
import { Form, Validators } from '../../../components/form/DynamicFormTs'
import { withRouter } from "react-router-dom";
import Http from '../../../Http';
import moment from 'moment';

class ContraRecibo extends FormComponent {

  componentDidMount() {
    let defaultUrl = this.props.clientesFacturas ? 'contra-recibo/cliente-factura' : 'contra-recibo/one';
    let saveUrl = this.props.clientesFacturas ? 'contra-recibo/cliente-factura-save' : 'contra-recibo/save';
    this.FormConfig(
      { defaultUrl, saveUrl, backUrl: '' },
      new Form([
        Form.Field('date', 'fecha', 'Fecha de recibo', new Date(), [], 2),
        Form.Field('number', 'plazo', 'Plazo (días)', false, [Validators.required], 4, [], [], [], false, true),
        Form.Field('date', 'vencimiento', 'Vencimiento', false, [Validators.required], 6, [], [], [], false, true),
      ], ['Marcar contrarecibo'], ''), this.formData
    )

    this.LoadPreds(this.props.factura.id, false);
  }

  formData = async (form) => {
    let newForm = form;
    /* newForm = Form.ValueChange(newForm, {
      fecha: this.onFechaChange
    }) */
    return newForm;
  }

  onFechaChange = (form, field) => {
    const { Value } = field;
    const plazo = form.Fields.find(f => f.Name === 'plazo');
    if(!plazo) return;
    let date = new Date(moment(Value).add(plazo.Value, 'd').format('YYYY-MM-DD HH:mm:ss'));
    form.Fields = form.Fields.map((field) => {
      if (field.Name !== 'vencimiento') return field;
      field.Value = date;
      return field;
    });
    return form ;
  }

  onSubmit = async (button, vals) => {
    this.setState({ loading: true });
    let data = {
      recibida_fecha: vals.fecha,
      vencimiento: vals.vencimiento,
      recibida: 1,
      id: this.props.factura.id
    }
    try {
      let Res = await Http.post(`${this.config.saveUrl}`, data);
      if(!Res.error) {
        this.props.onSave();
      } else {
        this.setState({ loading: false, sbMsg: `Error al guardar${(Res.errMsg ? `: ${Res.errMsg}` : '')}`, sbOpen: true });
      }
    } catch (error) {
      console.log(error)
    }
    this.setState({ loading: false });
  }

  
  formChange = (form, field) => {
    let newForm = { ...form };
    if (field.Name === 'fecha') {
      newForm = this.onFechaChange(form, field);
    }
    this.setState({ FormData: newForm }) 
  }

  render() {
    const { factura = {} } = this.props;
    return (
      <div style={{ backgroundColor: 'white' }}>
        <h4>Factura #{factura.tipo_cons}</h4>
        <this.FormRender />
      </div>
    )
  }
}

export default withRouter(ContraRecibo)
